/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import configuration */
import { KPI_OVERVIEW_GROUPS } from '@/config/kpi/tools/overviewConfig';

const WATER_LOSS_SENSOR_DESCRIPTIONS: Record<string, string> = {
    V_loss: 'Cumulative water loss in m³',
    qv_loss_7d: 'Water loss over the last 7 days in m³/h',
    dtc_7d: 'DTC value over the last 7 days',
    dtc: 'DTC value for the last day',
};

function getKpiDescription(group: string, sensorType: string): string | null {
    const groupConfig = KPI_OVERVIEW_GROUPS.find((entry) => entry.group === group);

    return groupConfig?.kpis[sensorType]?.description ?? null;
}

export function getSensorDeviceDescription(group: string, sensorType: string): string | null {
    if (group === 'WATER') {
        return WATER_LOSS_SENSOR_DESCRIPTIONS[sensorType] ?? null;
    }

    const kpiDescription = getKpiDescription(group, sensorType);

    if (kpiDescription) {
        return kpiDescription;
    }

    if (group === 'DTC') {
        return 'DTC error code';
    }

    if (group !== '-') {
        return null;
    }

    if (sensorType === '-') {
        return 'This is the primary sensor configured for this device.';
    }

    if (sensorType.startsWith('P')) {
        return 'Power sensor';
    }

    if (sensorType.startsWith('W')) {
        return 'Energy sensor';
    }

    if (sensorType === 'V') {
        return 'Volume flow sensor';
    }

    return null;
}
